<template>
  <section>
    <p class="muted">Indicadores baseados em verificações reais da API.</p>
    <div class="grid" style="margin-top: 1rem">
      <article class="panel" v-for="service in services" :key="service.name">
        <h2>{{ label(service.name) }}</h2>
        <p class="status" :class="service.status">{{ service.status }}</p>
        <p class="muted">{{ service.detail || 'Sem detalhes' }}</p>
        <p class="muted" v-if="service.latencyMs != null">{{ service.latencyMs }} ms</p>
      </article>
    </div>
    <p class="muted" style="margin-top: 1rem" v-if="error">{{ error }}</p>
    <p class="muted" style="margin-top: 1rem" v-else-if="loading">Carregando saúde dos serviços…</p>
  </section>
</template>

<script setup lang="ts">
import { onMounted, ref } from 'vue';

type ServiceHealth = {
  name: string;
  status: string;
  detail?: string;
  latencyMs?: number;
};

const services = ref<ServiceHealth[]>([]);
const loading = ref(true);
const error = ref('');

const names: Record<string, string> = {
  postgres: 'PostgreSQL',
  evolution: 'Evolution API',
  whatsapp: 'WhatsApp',
  deepseek: 'DeepSeek',
  google_calendar: 'Google Calendar',
};

function label(name: string) {
  return names[name] ?? name;
}

onMounted(async () => {
  try {
    const res = await fetch('/api/health');
    if (!res.ok) throw new Error(`HTTP ${res.status}`);
    const data = (await res.json()) as { services: ServiceHealth[] };
    services.value = data.services ?? [];
  } catch (err) {
    error.value = err instanceof Error ? err.message : 'Falha ao carregar saúde';
  } finally {
    loading.value = false;
  }
});
</script>
